import React, { useState } from "react";

export default function Payment() {
    const [formData, setFormData] = useState({
        name: "",
        phoneNumber: "",
        email: "",
        price: "",
        cardName: "",
        cardNumber: "",
        expiryMonth: "",
        expiryYear: "",
        cvc: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData);
    };

    return (
        <section className="relative py-[40px]">
            <div className="container flex flex-col gap-[25px]">
                <div className="flex flex-col items-center justify-center text-center gap-[4px] font-bold capitalize">
                    <div className="text-[22px] text-[#294A6A]">Please enter the information accurately</div>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="flex flex-col gap-[25px]">
                        <div className="f-col flex items-center justify-between gap-[10px]">
                            <div className="w-100 w-[33%] flex flex-col gap-[5px]">
                                <label className="font-bold text-[#294A6A] w-fit capitalize">Your Name</label>
                                <input
                                    className="outline-0 border-2 border-[#294A6A] rounded-[4px] px-[12px] py-[6px] text-[#294A6A]"
                                    type="text"
                                    placeholder="Your Name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="w-100 w-[33%] flex flex-col gap-[5px]">
                                <label className="font-bold text-[#294A6A] w-fit capitalize">Your Phone Number</label>
                                <input
                                    className="outline-0 border-2 border-[#294A6A] rounded-[4px] px-[12px] py-[6px] text-[#294A6A]"
                                    type="text"
                                    placeholder="Your Phone Number"
                                    name="phoneNumber"
                                    value={formData.phoneNumber}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="w-100 w-[33%] flex flex-col gap-[5px]">
                                <label className="font-bold text-[#294A6A] w-fit capitalize">Your Email</label>
                                <input
                                    className="outline-0 border-2 border-[#294A6A] rounded-[4px] px-[12px] py-[6px] text-[#294A6A]"
                                    type="email"
                                    placeholder="Your Email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>

                        <div className="pad-10 flex flex-col gap-[20px] shadow-[0px_0px_10px_#00000026] p-[40px] rounded-[4px]">
                            <div className="text-[22px] text-[#294A6A] font-bold capitalize">Complete your payment</div>
                            <div className="w-100 mx-auto w-[50%] h-[300px]">
                                <div className="visa-card h-[100%] p-[20px] bg-gradient-to-r from-[#1a2a3d] to-[#2c3e50] text-white rounded-lg shadow-lg flex flex-col">
                                    <div className="visa-card-header flex justify-between items-center">
                                        <div className="visa-logo font-bold text-xl text-[#f1c40f]">
                                            VISA
                                        </div>
                                        <div className="visa-chip bg-[#f1c40f] rounded-full w-10 h-10"></div>
                                    </div>
                                    <div className="font-1 visa-card-number mt-8 text-2xl font-mono tracking-widest">
                                        {formData.cardNumber ? formData.cardNumber.replace(/(\d{4})(?=\d)/g, "$1 ") : "#### #### #### ####"}
                                    </div>
                                    <div className="visa-card-info mt-6 flex justify-between text-sm font-medium">
                                        <div className="text-[#ecf0f1]">{formData.cardName || "Name on Card"}</div>
                                        <div className="text-[#ecf0f1]">{formData.expiryMonth && formData.expiryYear ? `${formData.expiryMonth}/${formData.expiryYear}` : "MM/YY"}</div>
                                    </div>
                                    <div className="visa-card-footer mt-auto pt-4 flex justify-between items-center">
                                        <div className="text-xs text-[#ecf0f1]"></div>
                                        <div className="text-xs text-[#ecf0f1]">Valid through</div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col justify-between gap-[10px]">
                                <div className="w-[100%] flex flex-col gap-[5px]">
                                    <label className="font-bold text-[#294A6A] w-fit capitalize">Name on card</label>
                                    <input
                                        className="outline-0 border-2 border-[#294A6A] rounded-[4px] px-[12px] py-[6px] text-[#294A6A]"
                                        type="text"
                                        placeholder="Name on card"
                                        name="cardName"
                                        value={formData.cardName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="w-[100%] flex flex-col gap-[5px]">
                                    <label className="font-bold text-[#294A6A] w-fit capitalize">Card number</label>
                                    <input
                                        className="outline-0 border-2 border-[#294A6A] rounded-[4px] px-[12px] py-[6px] text-[#294A6A]"
                                        type="text"
                                        placeholder="Card number"
                                        name="cardNumber"
                                        value={formData.cardNumber}
                                        onChange={handleChange}
                                        maxLength={16}
                                        pattern="\d{16}"
                                        required
                                    />
                                </div>
                                <div className="f-col flex gap-[15px]">
                                    <div className="w-100 w-[33%] flex flex-col gap-[5px]">
                                        <label className="font-bold text-[#294A6A] w-fit capitalize">Expiry date</label>
                                        <select
                                            className="outline-0 border-2 border-[#294A6A] rounded-[4px] px-[12px] py-[6px] text-[#294A6A]"
                                            name="expiryMonth"
                                            value={formData.expiryMonth}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">MM</option>
                                            {[...Array(12).keys()].map((i) => (
                                                <option key={i} value={String(i + 1).padStart(2, '0')}>
                                                    {String(i + 1).padStart(2, '0')}
                                                </option>
                                            ))}
                                        </select>
                                        <select
                                            className="outline-0 border-2 border-[#294A6A] rounded-[4px] px-[12px] py-[6px] text-[#294A6A]"
                                            name="expiryYear"
                                            value={formData.expiryYear}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">YY</option>
                                            {[...Array(10).keys()].map((i) => (
                                                <option key={i} value={String(23 + i).padStart(2, '0')}>
                                                    {String(23 + i).padStart(2, '0')}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="w-100 w-[33%] flex flex-col gap-[5px]">
                                        <label className="font-bold text-[#294A6A] w-fit capitalize">CVC code</label>
                                        <input
                                            className="outline-0 border-2 border-[#294A6A] rounded-[4px] px-[12px] py-[6px] text-[#294A6A]"
                                            type="text"
                                            placeholder="CVC code"
                                            name="cvc"
                                            value={formData.cvc}
                                            onChange={handleChange}
                                            maxLength={3}
                                            pattern="\d{3}"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="w-100 w-[33%] flex flex-col gap-[5px]">
                                    <label className="font-bold text-[#294A6A] w-fit capitalize">Enter Amount </label>
                                    <input
                                        className="outline-0 border-2 border-[#294A6A] rounded-[4px] px-[12px] py-[6px] text-[#294A6A]"
                                        type="number"
                                        placeholder="Enter Amount"
                                        name="price"
                                        value={formData.price}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <button
                                    className="w-fit capitalize my-[15px] bg-[#294A6A] px-[30px] py-[8px] rounded-[4px] text-white capitalize transition duration-500 hover:bg-[#273b4f]"
                                    type="submit"
                                >
                                    Complete Payment
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        </section>
    );
}
